import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const statusMessages = {
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    408: 'Request Timeout',
    429: 'Too Many Requests',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
};

function isErrorStatus(code) {
    return code >= 400 && code < 600;
}

export default function StatusPage() {
    const location = useLocation();
    const code = location.state?.statusCode ? parseInt(location.state.statusCode, 10) : null;
    const isError = code && isErrorStatus(code);
    const navigate = useNavigate();
    return (
        <div className="max-w-md mx-auto min-h-screen flex flex-col justify-center text-center">
            {isError ? (
                <div className="mt-8 p-4 rounded">
                    <h1 className={`text-6xl font-bold ${code >= 500 ? 'text-red-700' : 'text-yellow-300'}`}>
                        {code}
                    </h1>
                    <p className="text-2xl mt-2">{statusMessages[code] || 'Unknown Error'}</p>
                </div>
            ) : (
                <p className="mt-8 text-gray-500">
                    {code ? 'Not an error status code.' : 'No status code provided.'}
                </p>
            )}
            <div className="mt-8">
                <button onClick={() => navigate("/")} className="text-blue-500 hover:underline">
                    Go home
                </button>
            </div>
        </div>
    );
}
